<script setup lang="ts">
import {faChevronRight} from "@fortawesome/pro-regular-svg-icons";
import type {IconDefinition} from "@fortawesome/fontawesome-svg-core";

const isActive = defineModel<boolean>({default: false});
const props = defineProps<{
    icon?: IconDefinition
    trailingIcon?: IconDefinition
    color?: string
    img?: string
    label?: string
    hideChevron?: boolean
    disableHover?: boolean
    bordered?: boolean
    description?: string
}>()

const color = inject('color') ?? props.color;
</script>

<template>
    <UButton
        color="white"
        class="!scale-100 w-full hd-focusable-transition !ring-0 gap-3 bg-cool-gray-100 rounded-md text-left p-3"
        :class="{
            'shadow': !bordered,
            '!border-gray-300 !shadow-none hover:!border-primary-500 focus:!border-primary-500 !border !ring-1 !ring-white hover:!ring-primary-500 focus:!ring-primary-500': bordered,
            'hd-focusable-active': isActive,
            'hd-focusable-hover': !disableHover,
            'hd-focusable-focus': disableHover,
        }"
    >
            <span
                v-if="icon || img"
                class="flex flex-shrink-0 w-10 h-10 rounded-md items-center justify-center"
                :class="color ?? 'bg-primary-100 text-primary-500'"
            >
                <FontAwesomeIcon
                    v-if="icon"
                    :icon="icon"
                    size="lg"
                />
                <nuxt-img
                    v-else-if="img"
                    :src="img"
                    class="w-10 h-auto"
                />
            </span>
            <div v-if="[$slots.label || label, $slots.description || description].filter(n => !!n).length > 1" class="flex-1 h-full flex flex-col">
                <div v-if="$slots.label || label" class="block text-base font-medium" :class="{
                    '-mt-0.5': $slots.description || description
                }">
                    <slot name="label">{{ label }}</slot>
                </div>
                <div v-if="$slots.description || description" class="block font-normal text-sm" :class="{
                '-mt-0.5': label
                }">
                    <slot name="description">{{ description }}</slot>
                </div>
            </div>
            <div v-else-if="$slots.label || label" class="h-10 flex items-center text-base font-medium">
                <slot name="label">{{ label }}</slot>
            </div>
            <div v-else-if="$slots.description || description" class="h-10 flex items-center text-sm">
                <slot name="description">{{ description }}</slot>
            </div>
            <slot />
            <FontAwesomeIcon v-if="!hideChevron" :icon="trailingIcon ?? faChevronRight" class="mr-2"/>
    </UButton>
</template>